import { ICriteriaData } from '../CriteriaList';

export interface IBuilderMediaData {
  id: string;
  imageUrl?: string;
  qrCode?: boolean;
}
export interface IBuilderStep2Data extends IBuilderMediaData {
  content: string[];
  criteria: ICriteriaData[];
  textCriteria: ICriteriaData[][];
  eStatement: boolean;
}

const content1 =
  "<p class='ql-align-center'><h3 class='ql-align-center'><strong>Visa Rewards Benefits</strong></h3>" +
  '</p><p><br></p>' +
  '<p>The Visa Signature® Card is a good cash back credit card for people with good or excellent credit who' +
  ' want the opportunity to earn lots of bonus rewards without paying an annual fee. The Cash+ offer starts ' +
  'with an easy-to-earn sign-up bonus: ' +
  '$200 for spending $1,000 in the first 120 days. There’s no letup with its ongoing rewards, either, as ' +
  'cardholders earn 5% cash back on up to $2,000 spent in two bonus categories each quarter, plus ' +
  '<strong>unlimited 2% cash back</strong> in one quarterly bonus category and <strong>1% back on everything ' +
  'else</strong></p>';

const content2 =
  "<p><h3 class='ql-align-center'><strong>-</strong></h3>" +
  "<h3 class='ql-align-center'><strong>Please see message at end of statement for important policy update</strong>" +
  '</h3></p>';

const content3 =
  "<p><h3 class='ql-align-center'><strong>-</strong></h3>" +
  "<h3 class='ql-align-center'><strong>Please note: online banking will be down 2/28/23</strong></h3>" +
  '</p>';

export const builderStep2Data: IBuilderStep2Data[] = [
  {
    id: '1',
    imageUrl: '/infoTrac/images/step-2-img-3.png',
    qrCode: false,
    eStatement: true,
    content: [content1, content2, content3],
    criteria: [
      {
        id: '1',
        type: 'endBalance',
        is: true,
        moreThan: true,
        input: '10000.00',
      },
      {
        id: '2',
        type: 'interestRate',
        is: true,
        input: '000291838-003928163, 2949001934',
        between: true,
        min: '4.00',
        max: '6.00',
      },
    ],
    textCriteria: [
      [
        {
          id: '1',
          type: 'account',
          is: true,
          moreThan: false,
          input: '',
        },
      ],
      [
        {
          id: '1',
          type: 'zipCode',
          is: true,
          moreThan: false,
          input: '12345-32756',
        },
      ],
    ],
  },
  {
    id: '2',
    imageUrl: '/infoTrac/images/step-2-img-2.png',
    qrCode: false,
    eStatement: true,
    content: [content1, content2, content3],
    criteria: [
      {
        id: '1',
        type: 'productType',
        is: false,
        input: 'VISARewards',
      },
      {
        id: '2',
        type: 'account',
        is: true,
        input: '000291838-003928163, 2949001934',
      },
    ],
    textCriteria: [
      [
        {
          id: '1',
          type: 'zipCode',
          is: true,
          moreThan: false,
          input: '12345-32756',
        },
      ],
      [],
    ],
  },
  {
    id: '3',
    imageUrl: '/infoTrac/images/step-2-img-6.png',
    qrCode: true,
    eStatement: false,
    content: [content1, content2, content3],
    criteria: [],
    textCriteria: [
      [
        {
          id: '1',
          type: 'endBalance',
          is: true,
          moreThan: true,
          input: '10000.00',
        },
      ],
      [],
    ],
  },
];

export const builderStep2DataEndOfStatement: IBuilderStep2Data[] = [
  {
    id: '1',
    imageUrl: '/infoTrac/images/step-2-img-endOfStatement-1.png',
    eStatement: true,
    qrCode: false,
    content: [''],
    criteria: [
      {
        id: '1',
        type: 'interestRate',
        is: true,
        input: '000291838-003928163, 2949001934',
        between: true,
        min: '0.02',
        max: '0.05',
      },
      {
        id: '2',
        type: 'zipCode',
        is: false,
        input: '000291838-003928163, 2949001934',
      },
    ],
    textCriteria: [
      [
        {
          id: '1',
          type: 'endBalance',
          is: true,
          moreThan: true,
          input: '10000.00',
        },
      ],
      [],
    ],
  },
  {
    id: '2',
    imageUrl: '/infoTrac/images/unnamed.png',
    eStatement: true,
    qrCode: false,
    content: [],
    criteria: [
      {
        id: '1',
        type: 'account',
        is: true,
        input: '000291838-003928163, 2949001934',
      },
    ],
    textCriteria: [
      [
        {
          id: '1',
          type: 'endBalance',
          is: true,
          moreThan: true,
          input: '10000.00',
        },
      ],
      [],
    ],
  },
];

export const mediaModalData: IBuilderMediaData[] = [
  {
    id: '1',
    imageUrl: '/infoTrac/images/step-2-img-3.png',
  },
  {
    id: '2',
    imageUrl: '/infoTrac/images/step-2-img-2.png',
  },
  {
    id: '3',
    imageUrl: '/infoTrac/images/step-2-img-6.png',
  },
  {
    id: '4',
    imageUrl: '/infoTrac/images/step-2-img-1.png',
  },
  {
    id: '5',
    imageUrl: '/infoTrac/images/step-2-img-4.png',
  },
  {
    id: '6',
    imageUrl: '/infoTrac/images/step-2-img-endOfStatement-1.png',
  },
  {
    id: '7',
    imageUrl: '/infoTrac/images/unnamed.png',
  },
  {
    id: '8',
  },
  {
    id: '9',
  },
  {
    id: '10',
  },
  {
    id: '11',
  },
  {
    id: '12',
  },
];

export const builderStep3Data: ICriteriaData[] = [
  {
    id: '1',
    type: 'city',
    input: 'Memphis',
  },
  {
    id: '2',
    type: 'creditScore',
    input: '800',
  },
  {
    id: '3',
    type: 'accountNumber',
    input: '000291838',
  },
  {
    id: '4',
    type: 'zipCodes',
    input: '21367',
  },
];
